<script setup lang="ts">
import type { ToneGlyph } from '@/lib/tone'

// Same stroke grid for every glyph so swapping tones never shifts alignment.
const props = withDefaults(
  defineProps<{
    glyph: ToneGlyph
    size?: number
  }>(),
  { size: 14 },
)
</script>

<template>
  <svg
    v-if="props.glyph === 'check'"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M3 8.5 L6.5 12 L13 4.5" />
  </svg>
  <svg
    v-else-if="props.glyph === 'alert'"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M8 3.5 V9" />
    <path d="M8 12.2 V12.3" />
  </svg>
  <svg
    v-else-if="props.glyph === 'question'"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5.5 5.5 A2.6 2.6 0 1 1 8 9.2 V10" />
    <path d="M8 12.6 V12.7" />
  </svg>
  <svg
    v-else-if="props.glyph === 'skip'"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 12 L12 4" />
  </svg>
  <svg
    v-else-if="props.glyph === 'dot'"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      cx="8"
      cy="8"
      r="3"
      fill="currentColor"
      stroke="none"
    />
  </svg>
</template>
